var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.message)?_c('div',{staticClass:"alert alert-info",attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.message)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }